import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';

import * as UserActions from './store/actions/user';
import { bindActionCreators } from 'redux';
import UsersAPI from './services/sdks/user';
import Fallback from './components/Fallback';
import styled from 'styled-components';
import { TbBrandWhatsapp } from 'react-icons/tb';

const Container = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`;

const WppLink = styled.a`
	position: fixed;
	bottom: 24px;
	right: 24px;
	z-index: 100000;
	background: #25d366;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	width: 60px;
	height: 60px;
	border-radius: 12px;
`;

const AppWrapper = ({ user, children }) => {
	const isLoggedIn = useMemo(() => !!user, [user]);
	const [isLoading, setIsLoading] = useState(() => (isLoggedIn ? true : false));

	const fetchUser = useCallback(async () => {
		setIsLoading(true);

		try {
			const response = await UsersAPI.getOne(user?._id);

			if (response.data.user) {
				localStorage.setItem('state', JSON.stringify({ user: response.data.user }));
			}
		} catch (error) {}

		setIsLoading(false);
	}, [user]);

	useEffect(() => {
		if (isLoggedIn) {
			fetchUser(true);
		}
	}, [fetchUser, isLoggedIn]);

	if (isLoading) {
		return (
			<Container>
				<Fallback />
				<WppLink
					href='https://wa.me/+5518988187078?text=Ol%C3%A1!%20Vim%20do%20seu%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20por%20favor.'
					target='_blank'>
					<TbBrandWhatsapp style={{ fontSize: 40, color: '#FFF' }} />
				</WppLink>
			</Container>
		);
	}

	return (
		<Container>
			{children}
			<WppLink
				href='https://wa.me/+5518988187078?text=Ol%C3%A1!%20Vim%20do%20seu%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20por%20favor.'
				target='_blank'>
				<TbBrandWhatsapp style={{ fontSize: 40, color: '#FFF' }} />
			</WppLink>
		</Container>
	);
};

const mapStateToProps = ({ user }) => ({ user });
const mapDispatchToProps = (dispatch) => bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AppWrapper);
